import { PayloadAction } from '../../../../store.model';
import { UNREAD_CATEGORY_ID } from '../const/unread-category';
import { ActionType } from '../event-centre-dialog.action';
import {
    defaultState,
    EventCentreDialogState,
} from '../event-centre-dialog.state';
import { determineUnread } from '../function/determine-unread.function';
import { filterItems } from '../function/filter-items.function';
import { categoryTransformer } from '../transformer/category.transformer';
import { itemTransformer } from '../transformer/item.transformer';

import { Reload, ReloadResult } from './reload.action';

export function reloadReducer(
    state: EventCentreDialogState,
    action: PayloadAction<ActionType.NOTI__EC__RELOAD, Reload>,
): EventCentreDialogState {
    try {
        let nextCategories = categoryTransformer([]);
        nextCategories = determineUnread(nextCategories, []);
        const nextNavCategories = nextCategories.slice(1);
        const nextItems = [];

        const nextCat = nextCategories?.find(
            (e) => e.categoryId === UNREAD_CATEGORY_ID,
        );

        return {
            ...defaultState(),
            categories: nextCategories,
            navCategories: nextNavCategories,
            categoryId: nextCat?.categoryId,
            category: nextCat,
            items: nextItems,
            filteredItems: nextItems,
        };
    } catch (err) {
        console.log(err);
        return state;
    }
}

export function reloadResultReducer(
    state: EventCentreDialogState,
    action: PayloadAction<ActionType.NOTI__EC__RELOAD_RESULT, ReloadResult>,
): EventCentreDialogState {
    try {
        let nextCategories = categoryTransformer(action.payload.categories);
        nextCategories = determineUnread(nextCategories, action.payload.items);
        const nextNavCategories = nextCategories.slice(1);

        const nextItems = itemTransformer(
            action.payload.items,
            nextNavCategories,
        );

        const nextFilt = filterItems({
            items: nextItems,
            categoryId: state.categoryId,
            filterOpts: state.filterOpts,
            categories: nextCategories,
            orderBy: state.orderBy,
        });

        return {
            ...state,
            categories: nextCategories,
            navCategories: nextNavCategories,
            items: nextItems,
            filteredItems: nextFilt,
        };
    } catch (err) {
        console.log(err);
        return state;
    }
}
